// extracted by mini-css-extract-plugin
export default {"grid":"SectionBodyGrid_grid__17-36","block":"SectionBodyGrid_block__bTeZN"};